import { useState } from 'react'
import { BusinessSelector } from '@/components/BusinessSelector'
import { SupplierList } from '@/components/SupplierList'
import { SupplierDetail, SupplierCreateForm } from '@/components/SupplierDetail'
import { useBusinessContext } from '@/context/BusinessContext'

type View = 'list' | 'detail' | 'create'

export function SuppliersPage() {
  const { selectedBusinessId } = useBusinessContext()
  const [selectedSupplierId, setSelectedSupplierId] = useState<string | null>(null)
  const [view, setView] = useState<View>('list')

  const handleSupplierSelect = (id: string) => {
    setSelectedSupplierId(id)
    setView('detail')
  }

  const handleBack = () => {
    setSelectedSupplierId(null)
    setView('list')
  }

  return (
    <div data-testid="suppliers-page">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold text-gray-900">Suppliers</h1>
            <BusinessSelector />
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        {!selectedBusinessId ? (
          <div className="text-center py-12">
            <svg
              className="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            <h3 className="mt-2 text-sm font-medium text-gray-900">No business selected</h3>
            <p className="mt-1 text-sm text-gray-500">
              Select a business from the dropdown above to view suppliers.
            </p>
          </div>
        ) : view === 'detail' && selectedSupplierId ? (
          <SupplierDetail supplierId={selectedSupplierId} onBack={handleBack} />
        ) : view === 'create' ? (
          <SupplierCreateForm
            businessId={selectedBusinessId}
            onSuccess={(id) => handleSupplierSelect(id)}
            onCancel={handleBack}
          />
        ) : (
          <SupplierList
            businessId={selectedBusinessId}
            onSupplierSelect={handleSupplierSelect}
            onCreateNew={() => setView('create')}
          />
        )}
      </main>
    </div>
  )
}
